export interface ReportAmountBounds { minAmount?: number; maxAmount?: number }

export function validateReportAmountBounds(bounds: ReportAmountBounds = {}) {
  for (const value of [bounds.minAmount, bounds.maxAmount]) {
    if (value !== undefined && (typeof value !== 'number' || !Number.isFinite(value) || value < 0)) {
      throw new Error('Invalid report amount bounds');
    }
  }
  if (bounds.minAmount !== undefined && bounds.maxAmount !== undefined && bounds.minAmount > bounds.maxAmount) {
    throw new Error('Invalid report amount bounds');
  }
  return bounds;
}

export function applyReportAmountBounds<T>(query: T, bounds: ReportAmountBounds = {}): T {
  validateReportAmountBounds(bounds);
  let filtered: any = query;
  if (bounds.minAmount !== undefined) filtered = filtered.gte('amount', bounds.minAmount);
  if (bounds.maxAmount !== undefined) filtered = filtered.lte('amount', bounds.maxAmount);
  return filtered;
}

export const supportsReportAmounts = (type: string) => ['revenue-report', 'expense-report', 'water-meters'].includes(type);
